module.exports = __webpack_public_path__ + "static/media/filter.1a9d37a2.svg";